module.exports = __webpack_public_path__ + "img/logo.e23f44f0.png";